import ZoomableImage from '../../../../components/ZoomableImage';
import * as S from './style';

const ZoomableStepImage = ({ src, alt }) => (
  <ZoomableImage src={src} alt={alt}>
    <S.ImageWrapper>
      <S.Img src={src} alt={alt} />
    </S.ImageWrapper>
  </ZoomableImage>
);

export default ZoomableStepImage;
